"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = UIFieldset;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _taggedTemplateLiteralLoose2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteralLoose"));

var _sizes = require("HubStyleTokens/sizes");

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireWildcard(require("react"));

var _styledComponents = _interopRequireWildcard(require("styled-components"));

var _FieldsetContext = require("../context/FieldsetContext");

var _UIHelpIcon = _interopRequireDefault(require("../icon/UIHelpIcon"));

var _InputConstants = require("../input/InputConstants");

var _UIOverlay = _interopRequireDefault(require("../overlay/UIOverlay"));

var CustomRenderer = _interopRequireWildcard(require("../utils/propTypes/customRenderer"));

var _decorators = require("../utils/propTypes/decorators");

var _UIFormControl = _interopRequireDefault(require("./UIFormControl"));

var _elements = require("../elements");

function _templateObject4() {
  var data = (0, _taggedTemplateLiteralLoose2.default)(["\n      ::after {\n        content: ' *';\n      }\n    "]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = (0, _taggedTemplateLiteralLoose2.default)(["\n  padding-right: 0;\n  padding-bottom: 0;\n\n  ", ";\n"]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = (0, _taggedTemplateLiteralLoose2.default)(["\n  display: flex;\n  flex-direction: column;\n  padding-top: ", ";\n  padding-bottom: ", ";\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = (0, _taggedTemplateLiteralLoose2.default)(["\n  position: relative;\n  min-width: 0;\n  margin: 0;\n  padding: 0;\n  border: 0;\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

/**
 * Note: This is the standards-recommmended markup pattern, but some AT, like
 * VoiceOver doesn't yet read the legend as the label for the nested controls.
 * Link: https://www.powermapper.com/tests/screen-readers/labelling/fieldset-with-yes-no-radio-buttons/
 **/
var Outer = _styledComponents.default.fieldset.withConfig({
  displayName: "UIFieldset__Outer",
  componentId: "sc-1a3239w-0"
})(_templateObject());

var LabelWrapper = _styledComponents.default.div.withConfig({
  displayName: "UIFieldset__LabelWrapper",
  componentId: "sc-1a3239w-1"
})(_templateObject2(), function (_ref) {
  var hasLegend = _ref.hasLegend;
  return hasLegend && "" + _sizes.LABEL_DEFAULT_PADDING_TOP;
}, function (_ref2) {
  var hasHelp = _ref2.hasHelp,
      hasLegend = _ref2.hasLegend;
  return (hasHelp || hasLegend) && _sizes.LABEL_DEFAULT_PADDING_BOTTOM;
});

var FieldsetLegend = (0, _styledComponents.default)(function (props) {
  var children = props.children,
      className = props.className,
      id = props.id;
  return _react.default.createElement("span", null, _react.default.createElement("legend", {
    id: id,
    className: "sr-only"
  }, children), _react.default.createElement("span", {
    "aria-hidden": true,
    className: className
  }, children));
}).withConfig({
  displayName: "UIFieldset__FieldsetLegend",
  componentId: "sc-1a3239w-2"
})(_templateObject3(), function (props) {
  return props.required && (0, _styledComponents.css)(_templateObject4());
});

function UIFieldset(props) {
  var children = props.children,
      disabled = props.disabled,
      Legend = props.Legend,
      legend = props.legend,
      legendId = props.legendId,
      overlay = props.overlay,
      _size = props._size,
      _required = props._required,
      help = props.help,
      tooltip = props.tooltip,
      tooltipPlacement = props.tooltipPlacement,
      rest = (0, _objectWithoutProperties2.default)(props, ["children", "disabled", "Legend", "legend", "legendId", "overlay", "_size", "_required", "help", "tooltip", "tooltipPlacement"]);
  var hasOverlay = !!overlay;
  var computedDisabled = hasOverlay ? true : disabled;
  var renderedLegend = legend ? _react.default.createElement(Legend, {
    id: legendId,
    required: _required
  }, legend) : null;
  var renderedLegendWithTooltip = tooltip ? _react.default.createElement(_UIHelpIcon.default, {
    title: tooltip,
    tooltipPlacement: tooltipPlacement
  }, renderedLegend) : renderedLegend;
  return _react.default.createElement(Outer, (0, _extends2.default)({}, rest, {
    "aria-hidden": hasOverlay,
    disabled: computedDisabled
  }), _react.default.createElement("div", null, _react.default.createElement(LabelWrapper, {
    hasLegend: renderedLegendWithTooltip != null,
    hasHelp: help != null
  }, renderedLegendWithTooltip, help != null ? _react.default.createElement(_elements.Small, {
    className: "private-form__inlinehelp",
    use: "help"
  }, help) : null), _react.default.createElement(_FieldsetContext.FieldsetContextProvider, {
    value: (0, _react.useMemo)(function () {
      return {
        disabled: computedDisabled,
        size: _size
      };
    }, [computedDisabled, _size])
  }, _react.default.createElement("div", null, children))), overlay && CustomRenderer.render(overlay, {
    contextual: true,
    use: overlay.type === _UIOverlay.default ? 'light' : undefined
  }, {
    mergeType: 'aggressive'
  }));
}

UIFieldset.propTypes = {
  children: _propTypes.default.node,
  disabled: _propTypes.default.bool,
  Legend: (0, _decorators.hidden)(_propTypes.default.elementType.isRequired),
  legend: _propTypes.default.node,
  legendId: _propTypes.default.string,
  overlay: CustomRenderer.propType,
  tooltip: _UIFormControl.default.propTypes.tooltip,
  tooltipPlacement: _UIFormControl.default.propTypes.tooltipPlacement,
  help: _UIFormControl.default.propTypes.help,
  _size: _propTypes.default.oneOf(Object.keys(_InputConstants.INPUT_SIZE_OPTIONS)),
  _required: _propTypes.default.bool
};
UIFieldset.defaultProps = {
  disabled: _FieldsetContext.defaultFieldsetContext.disabled,
  Legend: FieldsetLegend,
  _required: false,
  _size: _FieldsetContext.defaultFieldsetContext.size,
  tooltipPlacement: 'top'
};
UIFieldset.displayName = 'UIFieldset';
module.exports = exports.default;


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/UIComponents/static-2.3729/js/form/UIFieldset.js
// module id = 670
// module chunks = 209 210 211 212